'use client';

import {
  InfiniteScroll,
  InfiniteScrollItem,
} from '@bts-web/design-system/component/infinite-scroll';
import { Locale } from '@bts-web/utils-lokalise';
import { SavingsPlanItemType } from '../types';
import {
  SavingsPlanItem,
  SavingsPlanItemProps,
} from '../SavingsPlansItem/SavingsPlansItem';
import { SAVINGS_PLANS_LIST_PAGE_SIZE } from '../../config/query';
import { SavingsPlansItemsSkeleton } from '../SavingsPlansLoadingSkeleton/SavingsPlansLoadingSkeleton';
import { SavingsPlansViewQuery } from '@bts-web/data-layer/server';
import { useSavingsPlansContext } from '../SavingsPlansContext/SavingsPlansContext.use-client';
import { NothingToShow } from '@bts-web/core-features/common';

interface SavingsPlansListProps {
  savingsPlans: SavingsPlansViewQuery['response']['savingsPlans'];
  applicationLocale: Locale;
  translations: SavingsPlanItemProps['translations'];
}

const SavingsPlansList = ({
  savingsPlans,
  applicationLocale,
  translations,
}: SavingsPlansListProps) => {
  const { loadMoreSavingsPlans } = useSavingsPlansContext();

  const savingsPlansNodes = savingsPlans?.edges?.map(
    (savingsPlan) => savingsPlan?.node,
  );

  if (!savingsPlansNodes?.length) {
    return <NothingToShow text={translations.savingsPlansListEmpty} />;
  }

  return (
    <div
      data-testid="savings-plans-list"
      style={{ minHeight: `${Math.min(92 * savingsPlansNodes.length, 440)}px` }}
    >
      <InfiniteScroll
        itemsPerPage={SAVINGS_PLANS_LIST_PAGE_SIZE}
        fetchMore={loadMoreSavingsPlans}
        hasMore={Boolean(savingsPlans?.pageInfo?.hasNextPage)}
        skeleton={<SavingsPlansItemsSkeleton />}
        items={savingsPlansNodes as InfiniteScrollItem[]}
        renderItemComponent={(savingsPlan) => (
          <SavingsPlanItem
            applicationLocale={applicationLocale}
            savingsPlan={savingsPlan as SavingsPlanItemType}
            translations={translations}
          />
        )}
      />
    </div>
  );
};

export { SavingsPlansList };
